export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/vincent-versluis-dfda154127cbbbe5ba425e0bb027f7b9.jpg";